<template>
  <div class="created">
		<van-popup round v-model="showPopup" get-container="body">
			<div class="pop-box">
				<div class="answer-create">
					<div class="title set">试题设置</div>
					<template v-for="(item,index) in form.questions">
						<div class="com-box set" :key="index">
							<div class="number">
								<span class="index">试题 {{index+1}}</span>
								<span class="del" v-if="form.questions.length > 1" @click="delSubject(index)">删除</span>
							</div>
							<van-field
								v-model="item.questionTitle"
								label="题目"
								placeholder="请输入题目"
								rows="1"
								type="textarea"
								autosize
							/>
							<template v-for="(item1, index1) in item.answers">
								<van-field
									:key="index1"
									v-model="item1.answerContext"
									:label="JSON.parse(item1.boolRight) ? '正确答案': '错误答案'"
									rows="1"
									type="textarea"
									placeholder="请输入错误答案"
									autosize
								>
									<div class="hanlde" slot="right-icon" v-if="!JSON.parse(item1.boolRight)">
										<van-icon name="close" :size="20" color="#E1282D"  v-if=" item.answers.length > 2" @click="delAnswer(item.answers,index1)"/>
										<van-icon name="add-o" :size="20" class="add" color="#06ae56" @click="addAnswer(item.answers)"/>
									</div>
								</van-field>
							</template>
						</div>
					</template>
					<div class="add-range-btn" @click="addSubject">
						<van-icon name="plus" />
						新增试题
					</div>
					<div class="footer" v-show="bottomIsShow">
						<div class="button" @click="onFailed">确定保存</div>
						<div class="button cancel" @click="onCancel">取消</div>
					</div>
					<div style="height:46px" v-if="form.questions.length > 1"></div>
				</div>
			</div>
		</van-popup>
  </div>
</template>

<script>
export default {
	props: {
		isCreateQuestion: {
			type: Boolean,
			default: false
		},
    activityId: [String, Number],
    questionType: {
      type: String,
      default: ''
    },
    isClone: {
      type: Boolean,
      default: false
    }
	},
  data() {
    return {
      bottomIsShow:true,//控制底部tabbar显示与隐藏
      defaultPhoneHeight:0, //屏幕默认高度
      nowPhoneHeight:0, //屏幕现在的高度
      form: {
        questions: [
          {
            questionTitle: '',
            sortNo: 0,
            type: 'radio',
            answers: [
              {answerContext: '',boolRight: true},
              {answerContext: '',boolRight: false}
            ]
          }
        ],
      },
    }
  },
  computed: {
    // activityId() {
    //   return  this.$route.query.activityId || ''
    // },
    //  isClone() {
    //   return this.$route.query.from == 'clone';
    // },
		showPopup: {
			get() {
				return this.isCreateQuestion
			},
			set(newval) {
				this.$emit('update:isCreateQuestion',newval)
			}
		}
  },
  watch:{
    nowPhoneHeight:function(){
      if(this.defaultPhoneHeight != this.nowPhoneHeight){
        // 当软键盘弹出,改变bottomIsSHow变量然后去控制bottom的显示与隐藏
        this.bottomIsShow=false;
      }else{
        // 相等代表软键盘收起后,与上同理
        this.bottomIsShow=true
      }
    },
  },
  created() {
    this.defaultPhoneHeight = window.innerHeight
    window.onresize = ()=>{ //这个方法会被调用两次,软键盘弹出后和软件收起后
      this.nowPhoneHeight = window.innerHeight 
    }
    this.queryQuestionList()
  },
  methods: {
    queryQuestionList() {
      let activityId = this.isClone ? '' : this.activityId 
      this.$api.question.queryQuestionList({
          activityId, 
          questionType: this.questionType
        }).then(res => {
        if (res.success && res.data.length) {
          this.form.questions = res.data
        }
      })
    },
    addSubject() {
      let sortNo = this.form.questions.length
      this.form.questions.push({
        questionTitle: '',
        sortNo: sortNo++,
        type: 'radio',
        answers: [
          {answerContext: '',boolRight: true},
          {answerContext: '',boolRight: false}
        ]
      })
    },
    delSubject(index) {
      this.form.questions.splice(index, 1)
    },
    delAnswer(answers,index) {
      answers.splice(index, 1)
    },
    addAnswer(answers) {
      if (answers.length > 3) {
        this.$toast('最多只能添加四个答案');
        return
      }
      answers.push({answerContext: '',boolRight: false})
    },
    onFailed() {
      let isAdopt = true
      function recursion(arr) {
        arr.forEach(item => {
          for(let [key,value] of Object.entries(item)) {
            if (!Array.isArray(value)) {
              if (value ==='') isAdopt = false
            }else {
              recursion(value)
            }
          }
        })
      }
      recursion(this.form.questions)
      if (!isAdopt) return this.$toast('请完善题试题');
      this.form.activityId = this.isClone ? '' : this.activityId
      let loading = this.$toast.loading({
        message: '保存中...',
        forbidClick: true,
      });
      this.$api.question.saveQuestions(this.form).then(res => {
        if (res.success) {
          loading.clear()
          this.$toast('保存成功')
					this.showPopup = false
					this.$emit("questionSuccess")
        }
      })
    },
    onCancel() {
			this.showPopup = false
    },
  },
  destroyed() {
    //页面销毁前要记得这个监听消除掉;
    window.onresize = null
  }
}
</script>

<style lang="stylus" scoped>
	.pop-box {
		width: 320px;
		height: 520px;
		overflow: auto;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
		background: #f4f4f4;
		
	}
  .answer-create{
    margin: 0 12px 12px 12px;
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 10px;
    }
    .com-box {
      padding: 10px;
      margin-top: 10px
      border-radius: 8px;
      background-color: #fff
      .number {
        display: flex;
        justify-content: space-between;
        padding: 10px 16px;
        span {
          color: #606266;
          font-weight: 600;
        }
        .del {
          color: #ff6b31;
          font-weight: none;
        }
      }
    }
    .set {
      padding: 2px
      margin-top: 10px;
      .hanlde {
        display: flex;
        .add {
          margin-left: 10px;
        }
      }
    }
    .add-range-btn {
      margin 15px
      padding 10px 0
      text-align: center
      color $mainTextColor
      font-size 14px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 8px
    }
    .footer {
      box-sizing: border-box
      position fixed
      left 0
      bottom 0
      padding 0 10px
      height 60px
      width 100%
      display: flex
      align-items: center
      justify-content: space-around
      padding-bottom constant(safe-area-inset-bottom)
      padding-bottom env(safe-area-inset-bottom)
      border-bottom-left-radius: 16px
      border-bottom-right-radius: 16px
      background-color #fff
      .button {
        padding 10px 40px
        border 1px solid $mainTextColor
        border-radius: 8px
        color #fff
        background-color: $mainTextColor
      }
      .cancel {
        color $mainTextColor
        background: #fff;
      }
    }
  }
</style>